/* unplugin-vue-components disabled */import { render } from "./plotInfo.vue?vue&type=template&id=c75810b8&scoped=true"
import script from "./plotInfo.vue?vue&type=script&lang=js"
export * from "./plotInfo.vue?vue&type=script&lang=js"

import "./plotInfo.vue?vue&type=style&index=0&id=c75810b8&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75810b8"]])

export default __exports__